import { Col, Row } from 'antd';
import React from 'react';

interface IProps {
  renderTitle: any;
  renderRight: any;
}

export const MainTitle = (props: IProps) => {
  return (
    <Row
      type="flex"
      gutter={[5, 5]}
      justify="space-between"
      align="middle"
      style={{
        padding: '0px 35px 14px 35px',
        borderBottom: '1px solid #f3f4f6',
      }}
      className="inter-normal"
    >
      <Col>
        <div style={{ fontSize: 18 }}>{props.renderTitle}</div>
      </Col>
      <Col>{props.renderRight}</Col>
    </Row>
  );
};
